import React from 'react'
import ChatListHeader from './ChatListHeader'
import ChatCard from './ChatCard'
import { useAppSelector } from '../../../../hooks/redux'
import { type RootState } from '../../../../store/store'
import _ from 'lodash'
import ChatUtils from '../../../../functions/chats/ChatUtils'
import { Link, useSearchParams } from 'react-router-dom'
import useUserType from '../../../../hooks/UseUserType'
import { nanoid } from 'nanoid'
import { type IChatListItem } from '../../../../types'
import dayjs from 'dayjs'
import { LANDLORD_OFFER_CHAT_VISIBLE_DURATION } from '../../../../constants'
import { ChatViewMode } from '../ChatListSh'



export const isPinnedChat = (chat: IChatListItem): boolean => {
    const isDev = process.env.REACT_APP_IS_DEV === 'true'
    if (isDev) {
        return (ChatUtils.isBSOSupport(chat) || ChatUtils.isBSOBroadcast(chat))
    }
    return ChatUtils.isBSOSupport(chat)
}


interface ChatListProps {
    isDesktop?: boolean
    activeChatId?: string
    mode: ChatViewMode
}

const ChatList = ({ isDesktop = false, activeChatId, mode }: ChatListProps): JSX.Element => {
    const [searchParams] = useSearchParams()
    const favorites = searchParams.get('filter') === 'favorites'
    const blocked = searchParams.get('filter') === 'blocked'
    const { currentUser } = useAppSelector((state: RootState) => state.user)
    const { userType } = useUserType()
    const userDevice = useAppSelector((state) => state.app.userDevice)
    const offers = useAppSelector((state) => state.offers.offers)
    const { chatList } = useAppSelector((state: RootState) => state.chatList)


    const ADMIN_ID = Number(process.env.REACT_APP_BSO_USER_ID)

    const isAdminChat = (chat: IChatListItem): boolean => {
        if (!Array.isArray(chat.UserIDs)) return false
        return chat.UserIDs.includes(ADMIN_ID)
    }
    const adminChats = chatList.filter(isAdminChat)
    const userChats = chatList.filter(chat => !isAdminChat(chat))


    const visibleChats = mode === 'admin' ? adminChats : userChats


    return (
        <>
            <div
                className={'bg-gray-200 bg-white'}
                style={isDesktop ? { height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 } : undefined}
            >
                {isDesktop
                    ?
                    <></>
                    // <div className="chats-desktop__list-header">
                    //     <ChatListHeader />
                    // </div>
                    : <ChatListHeader />
                }
                <div
                    className={`d-flex flex-column ${isDesktop ? 'chats-desktop__list-scroll' : 'overflow-y-auto'}`}
                    style={{ height: "100%", flex: isDesktop ? 1 : undefined, minHeight: isDesktop ? 0 : undefined }}
                >
                    {!favorites && !blocked
                        ? visibleChats // chatList
                            .filter(isPinnedChat)
                            .map((chat, index) => (
                                <ChatCard
                                    key={chat.id}
                                    blocked={_.some((currentUser as any).BlackList, (user) => user.id === chat.userID)}
                                    favorite={_.some((currentUser as any).FavoriteList, (user) => user.id === chat.userID)}
                                    chat={chat}
                                    isAdmin={true}
                                    isActive={activeChatId != null && String(chat.id) === activeChatId}
                                />
                            ))
                        : <></>
                    }

                    <div className={'d-flex flex-column  pb-12  bg-white'}>
                        {
                            _.map(
                                favorites || blocked
                                    ? _.filter(visibleChats, chat =>
                                        _.some(
                                            favorites ? (currentUser as any).FavoriteList : (currentUser as any).BlackList,
                                            favItem => favItem.id === chat.userID
                                        ) && chat?.userID != null
                                    )
                                    : _.filter(
                                        visibleChats.filter(chat => (
                                            !ChatUtils.isMessageOffer(chat)
                                        )),
                                        (chat) => (
                                            !isPinnedChat(chat) &&
                                            (
                                                chat?.userID != null &&
                                                chat?.userID !== Number(process.env.REACT_APP_BSO_USER_ID) &&
                                                (
                                                    chat?.LastMessage?.updatedAt !== '' ||
                                                    _.includes([/* Number(process.env.REACT_APP_BSO_USER_ID), */Number(process.env.REACT_APP_BSO_SUPPORT_USER_ID)], chat.userID)
                                                ) &&
                                                (
                                                    (
                                                        userType !== 'Landlord' ||
                                                        currentUser.id === Number(process.env.REACT_APP_BSO_USER_ID)
                                                    ) || (
                                                        offers.some((offer) => (
                                                            offer?.attributes?.User?.data?.id === chat.userID &&
                                                            (
                                                                !['Completed', 'Canceled'].includes(offer?.attributes?.Statuses?.[0]) ||
                                                                dayjs().diff(dayjs(offer?.attributes?.updatedAt), 'day', true) < LANDLORD_OFFER_CHAT_VISIBLE_DURATION
                                                            )
                                                        ))
                                                    )
                                                )
                                            )
                                        )
                                    ),
                                (chat, index) => (
                                    <ChatCard
                                        key={chat.id}
                                        blocked={_.some((currentUser as any).BlackList, (user) => user.id === chat.userID)}
                                        favorite={_.some((currentUser as any).FavoriteList, (user) => user.id === chat.userID)}
                                        chat={chat}
                                        isActive={activeChatId != null && String(chat.id) === activeChatId}
                                    />
                                ))
                        }
                    </div>
                    {!isDesktop
                        ? <>
                            <div className="m-0" style={{ height: '12.5rem' }}></div>
                            {!(userType === 'Landlord' && currentUser.id !== Number(process.env.REACT_APP_BSO_USER_ID))
                                ? <div className="fixed-bottom mw-450px mx-auto px-4 py-2 bg-white" style={{ bottom: userDevice === 'IPhone' ? '9.65rem' : '8.2rem', left: '0px', zIndex: 1000 }}>
                                    <Link to={`/${userType.toLowerCase()}/search?type=profiles`}>
                                        <div className="btn btn-bso fs-6 p-1 py-4 w-100">
                                            Start a new chat
                                        </div >
                                    </Link>
                                </div>
                                : <></>
                            }
                        </>
                        : <></>
                    }
                </div>

            </div>
        </>
    )
}

export default ChatList
